import { getDeleteRemarkEndpoint, methods } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import {
  CLEAR_VISIT_DATA,
  DELETE_VISIT_REMARK,
  DELETE_VISIT_REMARK_ERROR,
  DELETE_VISIT_REMARK_SUCCESS,
  GET_REMARKS,
  GET_REMARKS_ERROR,
  GET_REMARKS_SUCCESS,
  GET_VISIT_INFO,
  GET_VISIT_INFO_ERROR,
  GET_VISIT_INFO_SUCCESS,
  GET_VISITS,
  GET_VISITS_ERROR,
  GET_VISITS_SUCCESS,
  SET_DELETE_REMARK_ID,
  SET_EDIT_REMARK_ID,
  SET_CANCELLED_VISIT_ID,
  CLEAR_CANCELLED_VISIT_ID,
  SET_VISIT_ERROR,
} from './VisitsConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getRemarks = (visitId) => {
  const endpoint = `api/v1/visits/${visitId}/remarks`
  const action = {
    type: GET_REMARKS,
    extraData: { visitId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_REMARKS_SUCCESS,
      error: GET_REMARKS_ERROR,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

export const getVisits = ({
  visitsType = 'Upcoming',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fromDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchValue,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Offset,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Count,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypesFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  statusFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tagFilterRow,
}) => {
  const api = 'api/v1/visits'
  const include = visitsType === 'Upcoming' ? 'IsIncludeUpcoming' : 'IsIncludePast'
  let query = `?fromDateTime=${encodeURIComponent(fromDate)}&toDateTime=${encodeURIComponent(
    toDate,
  )}&Offset=${Offset}&Count=${Count}`

  if (searchValue) {
    query += `&SearchValue=${encodeURIComponent(searchValue)}`
  }
  if (visitTypesFilterRow) {
    query += `&${visitTypesFilterRow}`
  }
  if (statusFilterRow) {
    query += `&${statusFilterRow}`
  }
  if (tagFilterRow) {
    query += `&${tagFilterRow}`
  }

  query += `&${include}=true`

  const endPoint = api + query

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endPoint, 'GET', null, null, {
      success: GET_VISITS_SUCCESS,
      error: GET_VISITS_ERROR,
    })

    return {
      type: GET_VISITS,
    }
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setVisitError = (newErrorMessage) => {
  const action = {
    type: SET_VISIT_ERROR,
    params: newErrorMessage,
  }
  return action
}

export const clearVisitData = () => ({
  type: CLEAR_VISIT_DATA,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getVisitInfo(visitId) {
  const endpoint = `api/v1/visits/${visitId}`
  const action = {
    type: GET_VISIT_INFO,
  }
  apiCall(
    endpoint,
    'GET',
    null,
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    {
      success: GET_VISIT_INFO_SUCCESS,
      error: GET_VISIT_INFO_ERROR,
    },
    null,
    null,
    0,
    false,
  )
  return action
}

export const setDeleteRemarkId = (remarkId = null) => ({
  type: SET_DELETE_REMARK_ID,
  payload: remarkId,
})

export const setEditRemarkId = (remarkId = null) => ({
  type: SET_EDIT_REMARK_ID,
  payload: remarkId,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deleteVisitRemark = (visitId, remarkId) => {
  const endpoint = getDeleteRemarkEndpoint(visitId, remarkId)
  const action = {
    type: DELETE_VISIT_REMARK,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.DELETE, null, null, {
      success: DELETE_VISIT_REMARK_SUCCESS,
      error: DELETE_VISIT_REMARK_ERROR,
      extraData: { visitId, remarkId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setCancelledVisitId = (visitId) => ({
  type: SET_CANCELLED_VISIT_ID,
  payload: visitId,
})

export const clearCancelledVisitId = () => ({
  type: CLEAR_CANCELLED_VISIT_ID,
})
